export default {

    /**
     * calendar 
     */    
    SEARCH_CLUBEVENTS_URL: `${process.env.REACT_APP_SERVER_URL}/api/clubevent/embed_data`,
}